import { useAuth, logout } from 'wasp/client/auth';
import { AuthPageLayout } from './AuthPageLayout';

export default function PendingApprovalPage() {
  const { data: user } = useAuth();
  const isRejected = (user as any)?.accountStatus === 'rejected';

  return (
    <AuthPageLayout>
      <div className='flex flex-col items-center gap-4 text-center'>
        {isRejected ? (
          <>
            <div className='text-5xl'>🚫</div>
            <h2 className='text-xl font-semibold text-gray-800'>Account Not Approved</h2>
            <p className='text-sm text-gray-600 max-w-sm'>
              Unfortunately, your account application was not approved. If you believe this is an error,
              please contact us for assistance.
            </p>
          </>
        ) : (
          <>
            <div className='text-5xl'>⏳</div>
            <h2 className='text-xl font-semibold text-gray-800'>Awaiting Approval</h2>
            <p className='text-sm text-gray-600 max-w-sm'>
              Your account has been created and is awaiting approval from an administrator.
              You will receive an email once your account has been reviewed.
            </p>
          </>
        )}
        <button
          onClick={() => logout()}
          className='mt-2 text-sm text-blue-600 underline hover:text-blue-800'
        >
          Sign out
        </button>
      </div>
    </AuthPageLayout>
  );
}



